import {
  CONTENT_WIDTH,
  LANDSCAPE_CONTENT_WIDTH,
  withSlotWidths
} from 'components/shared/DocumentSheet/lib/docStyles';

export const SERVICE_KEY = 'details';

export const MONEY_COLUMNS = [
  { key: 'charge', label: 'Charge', name: 'Charge' },
  { key: 'ins_adjustment', label: ['Ins.', 'adj.'], name: 'Ins. adj.' },
  { key: 'allowed_amount', label: 'Allowed', name: 'Allowed' },
  { key: 'ins_payment', label: ['Ins.', 'paid'], name: 'Ins. paid' },
  { key: 'ins_balance', label: ['Ins.', 'balance'], name: 'Ins. balance' },
  { key: 'disc_wo', label: ['Disc./', 'W-O'], name: 'Disc./W-O', optional: true },
  { key: 'state_tax', label: ['State', 'tax'], name: 'State tax', optional: true },
  { key: 'local_tax', label: ['Local', 'tax'], name: 'Local tax', optional: true },
  { key: 'pt_paid', label: ['Pt.', 'paid'], name: 'Pt. paid', optional: true },
  { key: 'ptBalance', label: ['Pt.', 'balance'], name: 'Pt. balance' }
];

export const CLAIMS_COLUMNS = new Set([
  'ins_adjustment',
  'allowed_amount',
  'ins_payment',
  'ins_balance'
]);

export const NEGATIVE_COLUMNS = new Set(['ins_adjustment', 'disc_wo']);

export const MONEY_KEYS = MONEY_COLUMNS.map((column) => column.key);

export const OPTIONAL_KEYS = MONEY_COLUMNS.filter((column) => column.optional).map(
  (column) => column.key
);

export const COLUMN_NAME = Object.fromEntries(
  MONEY_COLUMNS.map((column) => [column.key, column.name])
);

export const HIDDEN_ALIASES = {
  discount: 'disc_wo',
  write_off: 'disc_wo',
  amount_paid: 'pt_paid'
};

export const PORTRAIT_MONEY_LIMIT = 7;

const PORTRAIT = { content: CONTENT_WIDTH, service: 300, money: 60 };
const LANDSCAPE = { content: LANDSCAPE_CONTENT_WIDTH, service: 380, money: 58 };

export const columnMetrics = (landscape) => (landscape ? LANDSCAPE : PORTRAIT);

/**
 * @param {object} params
 * @param {string[]} params.keys - Visible money column keys, in design order.
 * @param {boolean} params.landscape
 * @returns {Array<object>} DocTable column defs, widths resolved to percentages.
 */
export const buildColumns = ({ keys, landscape }) => {
  const metrics = columnMetrics(landscape);
  const visible = MONEY_COLUMNS.filter((column) => keys.includes(column.key));

  const columns = [
    { key: SERVICE_KEY, label: 'Service', align: 'left' },
    ...visible.map((column) => ({
      key: column.key,
      label: column.label,
      align: 'right',
      tabular: true,
      nowrap: true
    }))
  ];

  const slots = Object.fromEntries(visible.map((column) => [column.key, metrics.money]));

  return withSlotWidths(columns, slots, metrics.content);
};
